import { AHIcon, AHSeparator, ListItem } from "arkh";
import React from "react";

export function WACategoryFooterAdminButton(props: {
  title: React.ReactNode;
  onPress(): void;
}) {
  return (
    <ListItem
      isFirst
      isLast
      onPress={props.onPress}
      left={<AHIcon type="settings" spaceRight="small" color="darkText" />}
      right={<ListItem.NavArrow />}
    >
      <ListItem.Title>{props.title}</ListItem.Title>
    </ListItem>
  );
}

export function WACategoryHeaderAdminButton(props: {
  title: React.ReactNode;
  onPress(): void;
}) {
  return (
    <>
      <ListItem
        isFirst
        isLast
        right={<ListItem.NavArrow />}
        onPress={props.onPress}
      >
        <ListItem.Title>{props.title}</ListItem.Title>
      </ListItem>
      <AHSeparator spaceVertical="large" style={{ alignSelf: "stretch" }} />
    </>
  );
}
